// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "main[data-v-6b312c16]{min-height:100vh!important;min-height:100dvh!important}.auth-background[data-v-6b312c16]{background-color:#ddebfb;background-image:url(/assets/img/hospital.png);background-position-y:bottom;background-repeat:no-repeat;background-size:contain;height:100%;min-height:100dvh;padding-bottom:60px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
